import { Injectable } from '@angular/core';
import { DataObject } from '@shared/models/data-object.model';
import { map } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { SharedService } from '@shared/services/shared.service';
import { lowerNoSpaces } from '@shared/functions';
import { ICatalog } from '@shared/models/icommons.model';
import { HttpMethods } from '@cbre/http';

export interface TrackUserAction<T = DataObject> {
  actionId: number;
  actionDetails?: T;
}

@Injectable({ providedIn: 'root' })
export class TrackUserActionService extends HttpMethods {
  constructor(
    http: HttpClient,
    private sharedService: SharedService
  ) {
    super(http);
  }

  /**
   * Get the specific action by key or value (Name)
   * @returns Observable<ICatalog>
   */
  public getActionByKeyOrValue(searchBy: 'key' | 'value', valueToSearch: string | number) {
    const compareFn: Function = searchBy === 'key' ? this.compareKeys : this.compareValues;
    return this.sharedService
      .getAppCatalog()
      .pipe(map((list: ICatalog[]) => list.find(item => compareFn(item[searchBy], valueToSearch))));
  }

  /**
   * Register the action
   * @param payload TrackUserAction
   * @returns Observable
   */
  public registerAction(payload: TrackUserAction) {
    return this.httpPost('/usage/actions', payload);
  }

  private compareKeys(k1: number, k2: number) {
    return k1 === k2;
  }

  private compareValues(val1: string, val2: string) {
    return lowerNoSpaces(val1) === lowerNoSpaces(val2);
  }
}
